import Vue from 'vue';
Vue.component('status-message', {
    template: '#status-message',

    props: {
        message: {
            type: String,
            required: true
        },

        visible: {
            type: Boolean,
            required: true
        },
    },

    computed: {
        statusMessage: function () {
            return (this.visible) ? this.message : null;
        }
    }
});
